<windowsticker-summary-card
  *ngIf="
    this.inputProduct.type === 'WindowSticker' ||
    this.inputProduct.type === 'CustomWindowSticker'
  "
  [inputWindowSticker]="inputProduct"
  [inputSubProject]="inputSubProject"
  [inputProject]="inputProject"
  [index]="index"
  [client]="client"
>
</windowsticker-summary-card>
<board-summary-card
  *ngIf="this.inputProduct.type === 'Board'"
  [inputBoard]="inputProduct"
  [inputSubProject]="inputSubProject"
  [inputProject]="inputProject"
  [index]="index"
  [client]="client"
>
</board-summary-card>
<other-product-summary-card
  *ngIf="this.inputProduct.type === 'OtherProduct'"
  [inputOtherProduct]="inputProduct"
  [inputSubProject]="inputSubProject"
  [inputProject]="inputProject"
  [index]="index"
  [client]="client"
></other-product-summary-card>
